export enum SprintStates {
  Planned =  'Planned',
  Active = 'Active',
  Finished = 'Finished'
}
